import { render, staticRenderFns } from "./SpanQueryBuilder.vue?vue&type=template&id=2d40ac38&scoped=true&"
import script from "./SpanQueryBuilder.vue?vue&type=script&lang=ts&"
export * from "./SpanQueryBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./SpanQueryBuilder.vue?vue&type=style&index=0&id=2d40ac38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.1_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.73.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40ac38",
  null
  
)

export default component.exports